import React from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import './Navlink.css';

const Navlink = () => {

	const { pathname } = useLocation();

	return ( 
		<React.Fragment>
			<ul className="nav nav-tabs mt-0 view-nav">
				<li className="nav-item ">
					<NavLink 
						exact
						className={pathname === '/dashboard/viewers' ? "nav-link active" : "nav-link" }
						to='/dashboard/viewers'
					>بازدید های امروز
					</NavLink>
				</li>
				<NavDropdown title="گزارش" id="nav-dropdown" >
					<NavDropdown.Item as="span" eventKey="4.1" className="d-flex p-0">
					<NavLink
						className={pathname === '/dashboard/viewers/daily' ? "nav_link_dropdown active" :"nav_link_dropdown" } 
						to='/dashboard/viewers/daily'
					>روزانه
					</NavLink>
					</NavDropdown.Item>
					<NavDropdown.Divider />
					<NavDropdown.Item as="span" eventKey="4.2" className="d-flex p-0">
					<NavLink 
						className={pathname === '/dashboard/viewers/weekly' ? " nav_link_dropdown active" :"nav_link_dropdown" } 
						to='/dashboard/viewers/weekly'
					>هفتگی
					</NavLink>
					</NavDropdown.Item>
					<NavDropdown.Divider />
					<NavDropdown.Item as="span" eventKey="4.3" className="d-flex p-0">
						<NavLink 
							className={pathname === '/dashboard/viewers/monthly' ? "nav_link_dropdown active" :"nav_link_dropdown" } 
							to='/dashboard/viewers/monthly'
						>ماهانه
						</NavLink>
					</NavDropdown.Item>
					<NavDropdown.Divider />
					<NavDropdown.Item as="span" eventKey="4.4" className="d-flex p-0">
						<NavLink 
							className={pathname === '/dashboard/viewers/yearly' ? "nav_link_dropdown active" :"nav_link_dropdown" } 
							to='/dashboard/viewers/yearly'
						>سالانه
						</NavLink>
					</NavDropdown.Item>
				</NavDropdown>
			</ul>
		</React.Fragment>
	 );
}
 
export default Navlink;